import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';

// Components
import { MainComponent } from '../components/main/main.component';
import { AlarmComponent } from '../components/alarm/alarm.component';
import { LocationComponent } from '../components/location/location.component';
import { LocationBaseDataComponent } from '../components/location-base-data/location-base-data.component';
import { LocationUnitAnchoringComponent } from '../components/location-unit-anchoring/location-unit-anchoring.component';
import { UnitDetailComponent } from '../components/unit-detail/unit-detail.component';
import { UnitOverviewComponent } from '../components/unit-overview/unit-overview.component';
import { ManageUnitTemplatesComponent } from '../components/manage-unit-templates/manage-unit-templates.component';
import { UserInvitationCreateComponent } from '../components/user-invitation-create/user-invitation-create.component';
import { UserListComponent } from '../components/user-list/user-list.component';
import { UserDetailComponent } from '../components/user-detail/user-detail.component';
import { UserActivityLogComponent } from '../components/user-activity-log/user-activity-log.component';
import { UserOnboardComponent } from '../components/user-onboard/user-onboard.component';
import { ExportMeasurementComponent } from '../components/export-measurement/export-measurement.component';
import { GlobalMainComponent } from '../components/global-admin/global-main/global-main.component';
import { GlobalAlarmComponent } from '../components/global-admin/global-alarm/global-alarm.component';
import { GlobalSetCurrentTenantComponent } from '../components/global-admin/global-set-current-tenant/global-set-current-tenant.component';
import { GlobalUnitComponent } from '../components/global-admin/global-unit/global-unit.component';
import { TenantDetailComponent } from '../components/tenant-detail/tenant-detail.component';
// Guards
import { AuthGuard } from '../guards/auth.guard';


const routes: Routes = [
  // Authentication routes (no guard needed)
  { 
    path: 'Login', 
    component: MainComponent, 
    data: { requestedUrlBeforeLogin: 'Main' }
  }, // Will redirect to Auth0
  { 
    path: 'LoginGlobal', 
    component: MainComponent, 
    data: { requestedUrlBeforeLogin: 'GlobalAdmin' }
  }, // Will redirect to Auth0
  { path: 'Logout', component: MainComponent }, // Will handle logout
  { path: 'UserOnboard/:invitationExternalId', component: UserOnboardComponent },

  // Main application routes (protected)
  { path: 'Main', component: MainComponent, canActivate: [AuthGuard] },
  
  // Global Admin routes
  { path: 'GlobalAdmin', component: GlobalMainComponent, canActivate: [AuthGuard] },
  { path: 'Global/SetCurrentTenant', component: GlobalSetCurrentTenantComponent, canActivate: [AuthGuard] },
  { path: 'Global/MoveUnitBetweenTenants', component: GlobalUnitComponent, canActivate: [AuthGuard] },
  { path: 'Global/AlarmList', component: GlobalAlarmComponent, canActivate: [AuthGuard] },
  
  // Tenant routes
  { path: 'TenantDetail', component: TenantDetailComponent, canActivate: [AuthGuard] }, // TODO: Create TenantDetailComponent
  
  // Unit routes
  { path: 'UnitDetail/:id', component: UnitDetailComponent, canActivate: [AuthGuard] },
  { path: 'UnitOverview', component: UnitOverviewComponent, canActivate: [AuthGuard] },
  { path: 'ManageUnitTemplates', component: ManageUnitTemplatesComponent, canActivate: [AuthGuard] },
  
  // Location routes
  { path: 'LocationBaseDataEdit', component: LocationBaseDataComponent, canActivate: [AuthGuard] },
  { path: 'LocationUnitAnchoring', component: LocationUnitAnchoringComponent, canActivate: [AuthGuard] },
  { path: 'LocationOverview', component: LocationComponent, canActivate: [AuthGuard] },
  { 
    matcher: (segments) => {
      if (segments.length >= 1 && segments[0].path === 'LocationOverview' && segments.length > 1) {
        const path = segments.slice(1).map(s => s.path).join('/');
        return {
          consumed: segments,
          posParams: { path: new UrlSegment(path, {}) }
        };
      }
      return null;
    },
    component: LocationComponent, 
    canActivate: [AuthGuard] 
  },
  { path: 'LocationOverviewPrototype', component: LocationComponent, canActivate: [AuthGuard] }, // TODO: Create prototype version
  { path: 'AlarmOverview', component: AlarmComponent, canActivate: [AuthGuard] },
  
  // User routes
  { path: 'UserInvitationCreate', component: UserInvitationCreateComponent, canActivate: [AuthGuard] },
  { path: 'UserList', component: UserListComponent, canActivate: [AuthGuard] },
  { path: 'UserDetail/:userId', component: UserDetailComponent, canActivate: [AuthGuard] },
  { path: 'UserDetailCurrent', component: UserDetailComponent, canActivate: [AuthGuard] },
  { path: 'UserActivityLog', component: UserActivityLogComponent, canActivate: [AuthGuard] },
  
  // Export routes
  { path: 'ExportMeasurement', component: ExportMeasurementComponent, canActivate: [AuthGuard] },
  
  // CM navigation (external redirect)
  { path: 'cm/:cmpath', component: MainComponent, canActivate: [AuthGuard] }, // TODO: Handle CM redirect
  
  // Default route
  { path: '', redirectTo: '/Main', pathMatch: 'full' },
  
  // Wildcard route - must be last
  { path: '**', redirectTo: '/Main' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false, // Disabled to reduce console noise
    useHash: false, // Use HTML5 pushState
    onSameUrlNavigation: 'reload',
    initialNavigation: 'enabledBlocking' // Ensure router initializes before app
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
